import { OutletPropertyItem, OutletProperty } from "src/app/api/api-campaigns.service.generated";

export class OutletPropertiesConverter {
    static toProp(prop: string): OutletPropertyItem | undefined {
        const kv = prop.split(':');
        if (kv.length !== 2 || !kv[0] || !kv[1]) return undefined;
        return new OutletPropertyItem({outletProperty: this.getEnum(kv[0]), value: kv[1]});
    }

    private static getEnum(val: string): OutletProperty {
        switch (val) {
            case 'AdministrativeAreaL1':
                return OutletProperty.AdministrativeAreaL1;
            case 'AdministrativeAreaL2':
                return OutletProperty.AdministrativeAreaL2;
            default:
                return undefined;
        }
    }

    private static getEnumVal(val: OutletProperty): string {
        switch (val) {
            case OutletProperty.AdministrativeAreaL1:
                return 'AdministrativeAreaL1';
            case OutletProperty.AdministrativeAreaL2:
                return 'AdministrativeAreaL2';
            default:
                return undefined;
        }
    }

    static fromProp(prop: OutletPropertyItem): string {
        return `${this.getEnumVal(prop.outletProperty)}:${prop.value}`;
    }

    static toProps(props: string[]): OutletPropertyItem[] {
        return props ? props.map(t => this.toProp(t)).filter(t => t) : undefined;
    }

    static fromProps(props: OutletPropertyItem[]): string[] {
        return props ? props.map(t => this.fromProp(t)) : undefined;
    }

    static arePropsEqual(t1: OutletPropertyItem, t2: OutletPropertyItem) {
        return t1.outletProperty === t2.outletProperty && t1.value === t2.value;
    }
}